import { Configurator } from '@Config/Config';
import { Experiments } from '@Config/Experiments';
import { Variants } from '@Config/Variants';

export type ExperimentStatusDetails = {
  active: boolean;
  variant: Variants;
};
export type ExperimentSet = Record<Experiments, ExperimentStatusDetails>;

export function isExperimentActive(experiment: Experiments, experiments: ExperimentSet): boolean {
  return experiments[experiment] !== undefined && experiments[experiment].active;
}

export function getExperimentsWhichShouldGetInitiallyActivated(): ExperimentSet {
  const experiments: ExperimentSet = {} as ExperimentSet;

  Object.keys(Experiments).map(experiment => {
    experiments[Experiments[experiment]] = {
      active: checkIfExperimentShouldBeInitiallyActivated(Experiments[experiment]),
      variant: getExperimentVariation(Experiments[experiment])
    };
  });

  return experiments;
}

//region Development helper
export function getExperimentsFromDev(): ExperimentSet | undefined {
  const experimentsRaw = localStorage.getItem('experiments');
  if (experimentsRaw !== null) {
    return JSON.parse(experimentsRaw);
  }

  return undefined;
}

export function toggleDevExperiment(name: Experiments, variant: Variants): boolean {
  const experiments: ExperimentSet = Configurator.get('experiments');

  if (experiments[name] !== undefined && experiments[name].variant == variant) {
    // @ts-ignore
    delete experiments[name];
  } else {
    experiments[name] = {
      active: true,
      variant: variant
    };
  }

  Configurator.set('experiments', experiments);

  return true;
}

export function persistExperimentsForDev(): void {
  const experiments: Record<Experiments, Variants> = Configurator.get('experiments');

  localStorage.setItem('experiments', JSON.stringify(experiments));
}

export function clearExperimentsFromDev(): void {
  localStorage.removeItem('experiments');
}

export function refreshExperimentsForDev(): void {
  const experiments = getExperimentsFromDev();
  const experimentsCurrent: ExperimentSet = Configurator.get('experiments');

  Configurator.set('experiments', {
    ...experimentsCurrent,
    ...experiments
  });
}
//endregion

//region internal
function checkIfExperimentShouldBeInitiallyActivated(experiment: Experiments): boolean {
  const featureFlagCookie = getCookie('feature-flag-cookie');

  if (featureFlagCookie !== undefined) {
    const flags = JSON.parse(featureFlagCookie);

    if (flags[experiment] !== undefined) {
      return flags[experiment]['e'];
    }
  }

  return false;
}

function getExperimentVariation(experiment: Experiments): Variants {
  const featureFlagCookie = getCookie('feature-flag-cookie');

  if (featureFlagCookie !== undefined) {
    const flags = JSON.parse(featureFlagCookie);

    if (flags[experiment] !== undefined) {
      return flags[experiment]['v']['v_name'];
    }
  }

  return Variants.default;
}

function getCookie(name): string | undefined {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);

  if (parts.length === 2) {
    // @ts-ignore
    return parts
      .pop()
      .split(';')
      .shift();
  }

  return undefined;
}
//endregion
